'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paths = undefined;

var _tokenizer = require('./tokenizer');

var _tokenizer2 = _interopRequireDefault(_tokenizer);

var _parser = require('./parser');

var _parser2 = _interopRequireDefault(_parser);

var _transformer = require('./transformer');

var _transformer2 = _interopRequireDefault(_transformer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const cache = new Map();
const withPaths = ['path'];

const paths = exports.paths = factory('path');
exports.default = factory('data');


function factory(type) {
  return function (q) {
    let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (!cache.has(q)) cache.set(q, (0, _transformer2.default)((0, _parser2.default)((0, _tokenizer2.default)(q))));
    const fn = cache.get(q);
    const paths = withPaths.includes(type);
    const def = type === 'path' ? [] : void 0;
    if (data === null) return function (d) {
      return fn(d, paths)[type].getOr(def);
    };
    return fn(data, paths)[type].getOr(def);
  };
}